import { Map } from 'immutable';
import {
    GET_FAULTS_SUCCESS,
    SELECT_FAULT,
    START_DRAWING_FAULT,
    FINISH_DRAWING_FAULT,
    CANCEL_DRAWING_FAULT,
    START_DRAWING_FAULT_PHOTO,
    FINISH_DRAWING_FAULT_PHOTO,
    CANCEL_DRAWING_FAULT_PHOTO,
    GET_FAULT_PHOTOS_AND_VIDEOS_SUCCESS,
    EDIT_FAULT_SUCCESS,
    EDIT_FAULT_FAIL,
    ADD_FAULT_SUCCESS,
    ADD_FAULT_FAIL,
    GET_FAULT_TAGS_DICTIONARY_SUCCESS,
    DELETE_FAULT_SUCCESS,
    DELETE_FAULT_FAIL,
    SELECT_FAULT_BY_ID,
    CLEAR_MESSAGE,
} from './../types/faults';
import {
    SIGN_OUT,
} from './../types/auth';

const INITIAL_MAP = Map({
    message: { text: '', type: 'info' },
    faults: null,
    selectedFault: null,
    drawingFault: null,
    drawingFaultPhoto: null,
    faultPhotos: null,
    faultVideos: null,
    faultTagsDictionary: null
});
let updatedData = [];

export default (state = INITIAL_MAP, action) => {
    switch (action.type) {
        case GET_FAULTS_SUCCESS:
            return state
                .set('faults', action.faults);

        case GET_FAULT_PHOTOS_AND_VIDEOS_SUCCESS:
            return state
                .set('faultPhotos', action.faultPhotos)
                .set('faultVideos', action.faultVideos);

        case GET_FAULT_TAGS_DICTIONARY_SUCCESS:
            return state
                .set('faultTagsDictionary', action.faultTagsDictionary);

        case SELECT_FAULT:
            return state
                .set('faultPhotos', null)
                .set('faultVideos', null)
                .set('selectedFault', action.fault);

        case SELECT_FAULT_BY_ID:
            const fault = state.get('faults').find(fault => {
                return fault.id === action.faultId;
            });
            return state
                .set('faultPhotos', null)
                .set('faultVideos', null)
                .set('selectedFault', fault);

        case START_DRAWING_FAULT:
            return state
                .set('drawingFault', action.fault);

        case CANCEL_DRAWING_FAULT:
            return state
                .set('drawingFault', 'canceled');

        case FINISH_DRAWING_FAULT:
            return state
                .set('drawingFault', 'finished');

        case START_DRAWING_FAULT_PHOTO:
            return state
                .set('drawingFaultPhoto', {});

        case FINISH_DRAWING_FAULT_PHOTO:
            return state
                .set('drawingFaultPhoto', 'finished');
                
        case CANCEL_DRAWING_FAULT_PHOTO:
            return state
                .set('drawingFaultPhoto', 'canceled');

        case EDIT_FAULT_SUCCESS:
            updatedData = state.get('faults').map(row => {
                if (row.id === action.faultFeature.id) {
                    row = action.faultFeature;
                }
                return row;
            });
            return state
                .set('selectedFault', action.faultFeature)
                .set('faults', updatedData)
                .set('message',
                    {
                        text: 'Fault edited',
                        status: 'info'
                    })
                .set('updateType', EDIT_FAULT_SUCCESS);

        case EDIT_FAULT_FAIL:
            return state
                .set('message', { text: action.error.response.data, type: 'error' })
                .set('updateType', EDIT_FAULT_FAIL);

        case ADD_FAULT_SUCCESS:
            updatedData = state.get('faults').concat([action.faultFeature]);
            return state
                .set('selectedFault', action.faultFeature)
                .set('faults', updatedData)
                .set('message',
                    {
                        text: 'Fault added',
                        status: 'info'
                    })
                .set('updateType', ADD_FAULT_SUCCESS);

        case ADD_FAULT_FAIL:
            return state
                .set('message', { text: action.error.response.data, type: 'error' })
                .set('updateType', ADD_FAULT_FAIL);

        case DELETE_FAULT_SUCCESS:
            updatedData = state.get('faults').filter(row => row.id !== action.faultId);
            return state
                .set('message',
                {
                    text: 'Fault deleted',
                    status: 'info'
                })
                .set('selectedFault', updatedData[0])
                .set('faults', updatedData)
                .set('updateType', DELETE_FAULT_SUCCESS);

        case DELETE_FAULT_FAIL:
            return state
                .set('message', { text: action.error.response.data, type: 'error' });

        case CLEAR_MESSAGE:
            return state
                .set('message', { text: '', type: 'info' });        

        case SIGN_OUT:
            return INITIAL_MAP;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/faults.jsx